import axios from 'axios';
import cookies from 'js-cookie';

const repository = axios.create({
  baseURL: import.meta.env.VITE_APP_API_SERVER,
  withCredentials: true,
});

repository.interceptors.request.use(
  (config) => {
    const access_token = cookies.get('access_token');
    if (access_token) {
      config.headers = {
        Authorization: `Bearer ${access_token}`,
      };
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// repository.interceptors.request.use(config => {
// 	if(config.headers) {
// 		config.headers['accept-language'] = navigator.language
// 		config.headers['x-custom-lang'] = navigator.language
// 	}
//
// 	return config
// });

repository.interceptors.response.use(
  (config) => config,
  (error) => {
    console.log(error);
    if (error?.status == 401 || error?.response?.status == 401) {
      cookies.remove('access_token', { path: '/' });
      window.location.href = window.location.origin;
    }

    return Promise.reject(error);
  },
);

export default repository;
